import _ from 'lodash';
import type { ErrorOption } from 'react-hook-form';

export const convertObjectToFormData = (object?: Record<string, unknown>): FormData => {
  const formData = new FormData();
  if (object) {
    const preparedObject = prepareObjectForFormData(object);
    _.forIn(preparedObject, (value, key) => {
      if (typeof value !== 'undefined' && value !== null) {
        if (typeof value === 'number') {
          formData.append(key, value.toString());
        } else {
          formData.append(key, value);
        }
      }
    });
  }
  return formData;
};

/**
 * Converts validation error sent from server to form error for react-hook-form
 *
 * Input: [{ email: ['Email field is required'] }]
 *
 * Output: [{name: 'email', type: 'manual', message: 'Email field is required'}]
 */
export const convertValidationErrorToFormError = (
  object?: Record<string, string[]>
): (ErrorOption & { name: string })[] => {
  const errors: (ErrorOption & { name: string })[] = [];
  if (object) {
    _.forIn(object, (value, key) =>
      errors.push({
        name: key,
        message: value[0],
        type: 'manual',
      })
    );
  }
  return errors;
};

/**
 * Convert Data to Object
 *
 * Input: { id: [1, 2], title: ['Title One', 'Title Two'] }
 *
 * Output: { 'id[0]': 1, 'id[1]': 2, 'title[0]': 'Title One', 'title[1]': 'Title Two' }
 */
export const prepareObjectForFormData = (
  inputObject?: Record<string, unknown>
): Record<string, string | number | Blob | null> => {
  const objectForFormData: Record<string, string | number | Blob | null> = {};

  const injectData = (object?: Record<string, unknown>) => {
    if (object) {
      _.forIn(object, (value, key) => {
        if (typeof value !== 'undefined' && value !== null) {
          const data: Record<string, unknown> = {};
          switch (typeof value) {
            case 'number':
            case 'string':
              objectForFormData[key] = value;
              break;
            case 'boolean':
              objectForFormData[key] = value ? '1' : '0';
              break;
            case 'object':
              if (Array.isArray(value)) {
                value.forEach((val, index) => {
                  data[`${key}[${index}]`] = val;
                });
                injectData(data);
              } else if (value instanceof File) {
                objectForFormData[key] = value;
              } else if (value instanceof FileList) {
                for (let index = 0; index < value.length; index++) {
                  objectForFormData[`${key}[${index}]`] = value[index];
                }
              } else {
                _.forIn(value, (objValue, objKey) => {
                  data[`${key}[${objKey}]`] = objValue;
                });
              }
              injectData(data);
              break;
            default:
              break;
          }
        }
      });
    }
  };
  injectData(inputObject);
  return objectForFormData;
};
